import React from "react";
import { createContext, useContext, useReducer } from "react";

const default_data = {
  user: {},
};
const StateContext = createContext(default_data);

const DispatchContext = createContext(null);
const reducer = (state, { type, payload }) => { 
  switch (type) {
    case "SET_AUTH":
      return {
        ...state,
        user: payload,
      };

    default:
      console.log(`Unknow action type: ${type}`);
      throw new Error(`Unknow action type: ${type}`);
  }
};

export const PickupProvider = ({ children }) => {
  const [state, defaultDispatch] = useReducer(reducer, default_data);

  const dispatch = (type, payload) => defaultDispatch({ type, payload });

  return (
    <DispatchContext.Provider value={dispatch}>
      <StateContext.Provider value={state}>{children}</StateContext.Provider>
    </DispatchContext.Provider>
  );
};

export const usePickupState = () => useContext(StateContext);
export const usePickupDispatch = () => useContext(DispatchContext);
